// extracted by mini-css-extract-plugin
export default {"percent":"segment-chart_percent__Ci6xb","donut_svg":"segment-chart_donut_svg__GY0pa"};